import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./mixpanel";

/**
 * Fire a `page_viewed` event whenever the SPA route changes. Mounted once near
 * the router root; the path is normalized to a template inside `trackPageView`,
 * so personnel/incident ids never reach analytics.
 */
export function usePageTracking(): void {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
}
